export var PaymentEnum;
(function (PaymentEnum) {
    PaymentEnum["CreditCard"] = "CreditCard";
})(PaymentEnum || (PaymentEnum = {}));
export var PaymentVerifyResultEnum;
(function (PaymentVerifyResultEnum) {
    PaymentVerifyResultEnum["CardDeclined"] = "CardDeclined";
    PaymentVerifyResultEnum["UnknownCard"] = "UnknownCard";
    PaymentVerifyResultEnum["ExcessiveUserActivity"] = "ExcessiveUserActivity";
    PaymentVerifyResultEnum["GenericError"] = "GenericError";
    PaymentVerifyResultEnum["Success"] = "Success";
})(PaymentVerifyResultEnum || (PaymentVerifyResultEnum = {}));
//# sourceMappingURL=payment-method.js.map